<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add Subcategories
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Category Name"
                prepend-inner-icon="mdi-card-text-outline"
              />
            </v-col>
          </v-row>
          <v-divider class="my-5" />
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Subcategory
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "CategoryCreatePage",
  data() {
    return {
      form: {
        name: "",
        parent_id: "",
      },
      isLoading: false,
    };
  },
  computed: {
    categoryId() {
      return this.$route.params.categoryId;
    },
  },

  methods: {
    async save() {
      try {
        this.isLoading = true;
        const requestData = {
          name: this.form.name,
          parent_id: this.decryptIt(this.categoryId),
        };

        const response = await axios.post("/categories", requestData);

        if (response.data?.data) {
          this.$router.push(`/categories/${this.categoryId}/sub-categories`);
        } else {
          console.error("Failed to save category", response);
        }
      } catch (error) {
        console.error("Error saving category", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
